// extracted by mini-css-extract-plugin
module.exports = {"searchbox":"LocationDetails_searchbox__dd9vk","hr":"LocationDetails_hr__2rjYj","anchor":"LocationDetails_anchor__3y9kY"};